import { makeStyles } from "@material-ui/core/styles";
import { getCurrentGlobalContext } from "qpr-base/context/AppCtxProvider";
const useSlidesViewStyles = makeStyles({
  "@global": {
    body: {
      // backgroundColor: "rgb(238, 238, 243)",
    },
  },
  container: {
    minWidth: "100%",
    height: "100%",
    display: "flex",
    flexDirection: "column",
  },
  toolbar: {
    minHeight: "50px",
    minWidth: "100%",
    display: "flex",
    justifyContent: "space-between",
    borderBottom: "1px solid rgba(0, 0, 0, 0.1)",
    padding: "0 45px",
    "& .left": {
      display: "flex",
    },
    "& .toolIcon": {
      height: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: "49px",
    },
    "& .active": {
      background: "white",
      "& svg": {
        fill: "rgb(0,100,216)",
      },
    },
    "& .switch": {
      display: "flex",
      alignItems: "center",
      flexDirection: getCurrentGlobalContext().rtl ? "row-reverse" : "row",
      gap: "5px",
      "& .label": {
        fontFamily: "'Dubai'",
        fontStyle: "normal",
        fontWeight: 700,
        fontSize: "12px",
        textTransform: "uppercase",
        color: "#4C5157",
      },
      "& .inactive": {
        opacity: "0.5",
      },
    },
  },
  slide: {
    width: "100%",
    flexGrow: 1,
    display: "flex",
    justifyContent: "center",
    "& .highcharts-data-labels * text": {
      transform: "translate(0.133em, 0.5em)",
      fontSize: "0.75em !important",
    },
  },
  instructionsSlide: {
    margin: "30px",
    width: "100%",
    padding: "20px",
    background: "white",
    fontFamily: "unset",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",

    gap: "50px",
    alignItems: "center",
    "& .title": {
      fontFamily: "Dubai",
      fontStyle: "normal",
      fontWeight: 400,
      fontSize: "27.7228px",
      color: "#4C5157",
    },
    "& .actions": {
      display: "flex",
      justifyContent: "center",
      gap: "18px",
      position: "relative",
      top: "34px",
      "& button": {
        padding: "12px 28px",
        borderRadius: "50px",
        fontFamily: "'Dubai'",
        fontStyle: "normal",
        fontWeight: "400",
        textTransform: "unset",
        width: "160px",
        fontSize: "14px",
        "& .MuiButton-label": {
          display: "flex",
          alignItems: "center",
          gap: "13px",
        },
      },
      "& .addBtn": {
        background: "rgb(0,100,216)",
        color: "white",
        "& svg": {
          color: "white",
        },
      },
      "& .importBtn": {
        background: "#EEEEF3",
        color: "#4C5157",
        padding: "11.1px 18.5px 11.1px 22.38px",
        "& svg": {
          color: "#4C5157",
        },
      },
    },
  },
});

export default useSlidesViewStyles;
